import React, { useEffect, useState } from "react";
import { useTour } from "./TourProvider";
import { DESIGN_CONFIG } from "utils";

export default function TourOverlay() {
  const { steps, stepIndex, running, next, skip } = useTour();
  const [rect, setRect] = useState(null);

  const step = steps[stepIndex];

  const isFullyVisible = (r) => {
    return (
      r.top >= 0 &&
      r.left >= 0 &&
      r.bottom <= window.innerHeight &&
      r.right <= window.innerWidth
    );
  };

  useEffect(() => {
    if (!step) return;

    const element = document.querySelector(`[data-tour="${step.target}"]`);
    if (!element) return;

    const updateRect = () => {
      let target = element;

      if (element.children.length === 1) {
        target = element.children[0];
      }

      const r = target.getBoundingClientRect();

      const rectData = {
        bottom: Math.round(r.bottom),
        height: Math.round(r.height),
        left: Math.round(r.left),
        right: Math.round(r.right),
        top: Math.round(r.top),
        width: Math.round(r.width),
      };

      setRect(rectData);
    };

    const scrollToElement = () => {
      const r = element.getBoundingClientRect();

      if (!isFullyVisible(r)) {

        const offset = step.scrollOffset ?? 200;
        const elementTop = r.top + window.scrollY;

        window.scrollTo({
          behavior: "smooth",
          top: elementTop - offset,
        });

      }
    };

    scrollToElement();

    const timer = setTimeout(updateRect, 500);

    window.addEventListener("scroll", updateRect, true);
    window.addEventListener("resize", updateRect);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "";
      window.removeEventListener("scroll", updateRect, true);
      window.removeEventListener("resize", updateRect);
    };
  }, [step]);

  useEffect(() => {
    if (!running) return;

    const timer = setTimeout(() => {
      next();
    }, 10000);

    return () => clearTimeout(timer);
  }, [stepIndex, running]);

  if (!running || !rect) return null;

  const padding = 6;

  const height = rect.height + padding * 2;
  const left = rect.left - padding;
  const top = rect.top - padding;
  const width = rect.width + padding * 2;

  return (
    <>
      <div
        style={{
          backdropFilter: "blur(6px)",
          background: DESIGN_CONFIG.color.common.overlay,
          height: top,
          left: 0,
          position: "fixed",
          top: 0,
          width: "100%",
          zIndex: 9998
        }}
      />

      <div
        style={{
          backdropFilter: "blur(6px)",
          background: DESIGN_CONFIG.color.common.overlay,
          bottom: 0,
          left: 0,
          position: "fixed",
          top: top + height,
          width: "100%",
          zIndex: 9998
        }}
      />

      <div
        style={{
          backdropFilter: "blur(6px)",
          background: DESIGN_CONFIG.color.common.overlay,
          height: height,
          left: 0,
          position: "fixed",
          top: top,
          width: left,
          zIndex: 9998
        }}
      />

      <div
        style={{
          backdropFilter: "blur(6px)",
          background: DESIGN_CONFIG.color.common.overlay,
          height: height,
          left: left + width,
          position: "fixed",
          right: 0,
          top: top,
          zIndex: 9998
        }}
      />

      {step.render && step.render({ rect, skip })}
    </>
  );
}
